import * as _ from 'lodash'
import {
WB_UserRow
} from "../PA.Core/PAdbSchemaRows";
import {UserBO} from "./UserBO";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_User} from "../PA.Core/PAdbSchema";


export class UserBOValidations{

    static async ValidateEmptyFields(aBO: UserBO): Promise<void> {


        ErrorMessage_restate(aBO.ValidateMessageProvider,
            (_.isEmpty(aBO.drWB_User.cif.AUTHUSR_ID)),
            'BlankUserId', "User ID is blank")

        let ctxNoCache = new PAdbContext()
        let dups = <WB_UserRow[]>await ctxNoCache.findAll(esWB_User, {
            where: {
                WB_AUTHUSR_ID: {neq: aBO.drWB_User.cif.WB_AUTHUSR_ID},
                AUTHUSR_ID: aBO.WB_User.cif.AUTHUSR_ID
            }
        })

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            (dups.length > 0),
            'UserExists', "User Id Already Exists")


    }
}
